import { useEffect, useState } from "react";

export const useAnimationState = (isVisible: boolean) => {
  const [scrollDirection, setScrollDirection] = useState<"up" | "down">("down");

  useEffect(() => {
    if (isVisible) {
      setScrollDirection("up");
    } else {
      setScrollDirection("down");
    }
  }, [isVisible]);

  return { scrollDirection };
};
